const Pagination = ({ tableLib }) => (
  <footer className="flex justify-end items-center my-4 gap-2">
    <button
      className="px-2 py-1 text-sm text-white bg-secondary rounded-md shadow 
                    hover:bg-secondary_dark 
                    disabled:bg-gray-400 disabled:cursor-not-allowed"
      disabled={!tableLib.getCanPreviousPage()}
      onClick={() => tableLib.setPageIndex(0)}
    >
      First Page
    </button>
    <button
      className="px-2 py-1 text-sm text-white bg-secondary rounded-md shadow 
                    hover:bg-secondary_dark 
                    disabled:bg-gray-400 disabled:cursor-not-allowed"
      disabled={!tableLib.getCanPreviousPage()}
      onClick={tableLib.previousPage}
    >
      Previous Page
    </button>
    <span>{`page ${
      tableLib.getState().pagination.pageIndex + 1
    } of ${tableLib.getPageCount()}`}</span>
    <button
      className="px-2 py-1 text-sm text-white bg-secondary rounded-md shadow 
                    hover:bg-secondary_dark 
                    disabled:bg-gray-400 disabled:cursor-not-allowed"
      disabled={!tableLib.getCanNextPage()}
      onClick={tableLib.nextPage}
    >
      Next Page
    </button>
    <button
      className="px-2 py-1 text-sm text-white bg-secondary rounded-md shadow 
                    hover:bg-secondary_dark 
                    disabled:bg-gray-400 disabled:cursor-not-allowed"
      disabled={!tableLib.getCanNextPage()}
      onClick={() => tableLib.setPageIndex(tableLib.getPageCount() - 1)}
    >
      Last Page
    </button>
    <span>Show: </span>
    <select
      className="px-2 py-1 text-sm text-gray-600 bg-white rounded-md shadow border"
      disabled={!tableLib.getCanNextPage()}
      value={tableLib.getState().pagination.pageSize}
      onChange={(e) => tableLib.setPageSize(parseInt(e.target.value, 10))}
    >
      {[10, 20, 30, 40, 50].map((size) => (
        <option key={size} value={size}>
          {size}
        </option>
      ))}
    </select>
    <span> items per page</span>
  </footer>
)

export default Pagination
